import { CreateService, CRUDServiceInterface } from '@/services/service';
import { SurveyQuestionPointEntity } from '@/entities/survey-question-point.entity';

export default class SurveyQuestionPointService
  extends CreateService<SurveyQuestionPointEntity>('survey-question-point')
  implements CRUDServiceInterface<SurveyQuestionPointEntity>
{
  async getMany(): Promise<SurveyQuestionPointEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }
}
